import { identity, isDate, isNumber, isString, pickBy, set, toPairs } from 'lodash'
import { castDateAsParam, displayDate } from './dateHelper'

export const cleanObject = <T extends object>(value: T): Partial<T> => {
    const cleanedValue = pickBy(value, identity)
    return cleanedValue
}

export const castObjectAsParam = <T extends object>(value: T): any => {

    const params = pickBy(value, identity)

    for (const [key, value] of toPairs(params)) {
        if (value instanceof Date) {
            set(params, key, castDateAsParam(value))
        }
    }

    return params
}

export const convertObject = <T extends object>(objectValue: T): T => {

    for (const [key, value] of toPairs(objectValue)) {

        if (value !== undefined && value !== null && isString(value) && key.includes("Date")) {

            let convertedDate = new Date(value as any)

            if (!isNaN(convertedDate.getTime())) {
                set(objectValue, key, convertedDate)
            }
        }
    }

    return objectValue as T
}

export const castObjectToString = (obj: object): string => {


    if (isDate(obj))
        return displayDate(obj)

    if (isString(obj))
        return (obj as string).replace("\n", " ").replace("\r", " ").replace("\r\n", " ")

    if (isNumber(obj))
        return obj + ""

    return "";
}

// usage: await sleep(<duration>);
export const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

